import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { ModuleFE_LogTemplate_OLD } from '@app/hcs-frontend';
import { DropDown_DefaultCaret } from '@app/styles/frontend/ui/consts';
import { SimpleListAdapter, TS_DropDown } from '@nu-art/thunderstorm-frontend';
export const Editor_StateSmartDoc_Modules = [ModuleFE_LogTemplate_OLD];
export const Editor_StateSmartDoc = (props) => {
    const editable = props.editable;
    const logTemplates = ModuleFE_LogTemplate_OLD.cache.all();
    const adapter = SimpleListAdapter(logTemplates, log => _jsx(_Fragment, { children: log.item.title }));
    const selected = logTemplates.find(log => log._id === editable.item.logTemplates?.[0]?.templateId);
    return _jsx(TS_DropDown, { caret: DropDown_DefaultCaret, disabled: !props.editMode, adapter: adapter, selected: selected, onSelected: logTemplate => {
            editable.set('logTemplates', [{ templateId: logTemplate._id }]);
        } });
};
//# sourceMappingURL=Editor_StateSmartDoc.js.map